export const SET_USER_INFO = "SET_USER_INFO";
export const LOGOUT = "LOGOUT";
